import ConfigPage from "./screens/ConfigPage";
import ParamsConfig from "./screens/ParamsConfig";
import DashBoard from "./screens/DashBoard";
import EvaluationsConfig from "./screens/EvaluationsConfig";

import SysUsersConfigPage from "./screens/SysUsersConfigPage";
// import LevelsConfigPage from './screens/LevelsConfigPage';

const routes = [
  {
    collapse: true,
    name: "Configuración",
    icon: "nc-icon nc-settings-gear-65",
    state: "configCollapse",
    sidebar: true,
    roleID: ["CONFIG", "TEACHER", "TUTOR"],
    views: [
      {
        path: "/config/calendar",
        name: "Calendario",
        exact: true,
        mini: "C",
        // icon: "fa fa-gear",
        sidebar: true,
        component: ConfigPage,
        layout: "/admin",
        roleID: ["CONFIG", "TEACHER", "TUTOR"],
      },

      {
        path: "/config/sysusers",
        name: "Administracion de personal",
        exact: true,
        mini: "C",
        // icon: "fa fa-gear",
        sidebar: true,
        component: SysUsersConfigPage,
        layout: "/admin",
        roleID: ["CONFIG"],
      },
      {
        path: "/config/dashboard",
        name: "Panel de control",
        exact: true,
        mini: "PC",
        // icon: "fa fa-gear",
        sidebar: true,
        component: DashBoard,
        layout: "/admin",
        roleID: "CONFIG",
      },
      {
        path: "/config/params",
        name: "Parámetros del sistema",
        exact: true,
        mini: "PS",
        // icon: "fa fa-gear",
        sidebar: true,
        component: ParamsConfig,
        layout: "/admin",
        roleID: "CONFIG",
      },
      {
        path: "/config/evals",
        name: "Evaluaciones",
        exact: true,
        mini: "Ev",
        // icon: "fa fa-gear",
        sidebar: true,
        component: EvaluationsConfig,
        layout: "/admin",
        roleID: "EVALS",
      },
    ],
  },
];

export default routes;
